import App from './components/app/App';
import React from 'react';
import { WORKFLOW_ACCESS } from '../../global/app-global-values';

const TenantLookup = () => <App />;

export default {
  routeProps: {
    path: '/tenant-configuration',
    component: TenantLookup,
  },
  name: 'TenantLookup',
  label: 'Tenant Configuration',
  iconClassName: 'icon-tab',
  active: true,
  accessGroup: WORKFLOW_ACCESS,
};
